import { useRef } from 'react';

function useRefValue(value) {
  const memoValue = useRef(value);
  memoValue.current = value;

  return memoValue;
}

export default useRefValue;
